document.addEventListener("DOMContentLoaded", function () {
    // Store collection info on product link click
    document.querySelectorAll('.card-product-link').forEach(link => {
      link.addEventListener('click', function () {
        
        const title = this.closest('[data-handle]').getAttribute('data-collection-title');
        const url = this.closest('[data-handle]').getAttribute('data-handle');

      //  debugger;
        if (title && url && location.pathname !=  "/") {
          localStorage.setItem('last_collection_title', title);
          localStorage.setItem('last_collection_url', url);
        }
        else{
          if(!title && !url){
            const title = this.getAttribute('data-collection-title');
            const url = this.getAttribute('data-handle');
            localStorage.setItem('last_collection_title', title);
          localStorage.setItem('last_collection_url', url);
          }
        }
        //  if(location.pathname ==  "/"){
        //   localStorage.removeItem("last_collection_title");
        //   localStorage.removeItem("last_collection_url");
        // }
      });
    });

   
    //NEW BREADCRUMB JS
    const el = document.getElementById('breadcrumb-collection');
    const title = localStorage.getItem('last_collection_title');
    const url = localStorage.getItem('last_collection_url');

    
    //debugger;
    // Only display if on a product page
    if (el && title && url && window.location.pathname.includes('/products/')) {
      //  debugger;
       el.innerHTML = `<a href="${url}" class="nav-link text-[rgba(var(--colors-text-link))] relative h-fit before-link">${title}</a> <span class="breadcrumb__divider border-[rgba(var(--colors-text))] w-2.5 border-b inline-block bottom-1 ml-1 mr-1" aria-hidden="true"></span>
 `;
      //el.innerHTML = `<a href="${url}" class="nav-link text-[rgba(var(--colors-text-link))] relative h-fit before-link">${title}</a>`;
    }
  
});
